import countries from "../data/countries.json"
import type { Country } from "../types"

export const COUNTRIES = countries as [Country, ...Country[]]

export const EUROPEAN_COUNTRY_CODES = [
  "AL",
  "AT",
  "BA",
  "BE",
  "BG",
  "CH",
  "CZ",
  "DE",
  "DK",
  "EE",
  "ES",
  "FI",
  "FR",
  "GB",
  "GE",
  "GL",
  "GR",
  "HR",
  "HU",
  "IE",
  "IS",
  "IT",
  "LT",
  "LU",
  "LV",
  "ME",
  "MK",
  "MT",
  "NL",
  "NO",
  "PL",
  "PT",
  "RO",
  "RS",
  "SE",
  "SI",
  "SK",
  "SM",
  "SX",
  "TR",
]
